module.exports = __webpack_public_path__ + "img/logo-completa.ecf49189.png";